import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DialogModule } from '@progress/kendo-angular-dialog';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';

import { MainViewModule } from '../main-view/main-view.module';
import { SchedulerNavigationModule } from '../shared/kendo-scheduler-navigation/scheduler-navigation.module';
import { TranslationModule } from '../shared/translation/translation.module';

import { MyMeetingsViewComponent } from './my-meetings-view.component';
import { RescheduleViewComponent } from './reschedule-view/reschedule-view.component';

import { MeetingsService } from './my-meetings-view.service';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { SharedService } from '../shared/shared.service';
import { RescheduleViewService } from './reschedule-view/reschedule-view.service';

import { CanDeactivateGuard } from '../can-deactivate.guard';

@NgModule({
  declarations: [
    MyMeetingsViewComponent,
    RescheduleViewComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    RouterModule,
    FormsModule,
    InputsModule,
    ButtonsModule,
    SchedulerModule,
    ReactiveFormsModule,
    MainViewModule,
    SchedulerNavigationModule,
    TranslationModule
  ],
  providers: [
    MeetingsService,
    SpinnerService,
    SharedService,
    RescheduleViewService,
    CanDeactivateGuard
],
})
export class MyMeetingsViewModule { }
